import { WifiOff } from 'lucide-react';
import { useOnline } from '../../lib/useOnline';
import { ContextBanner } from '../../ui/Blocks';

/**
 * Baner „Brak połączenia” (DESIGN §7 stany: brak połączenia, mobile; MVP §14): widać to, co już wczytane, ale
 * zatwierdzenia, wysyłka i zapisy czekają na sieć — mutacje offline są odrzucane (lib/offline.ts), niczego nie
 * zatwierdzamy lokalnie.
 */
export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="mx-auto max-w-[1104px] px-4 pt-4 md:px-8">
      <ContextBanner tone="warning" icon={WifiOff}>
        <span className="font-medium">Brak połączenia.</span> Zatwierdzenia, wysyłka i zapisy wymagają sieci — niczego
        nie zatwierdzamy bez połączenia.
      </ContextBanner>
    </div>
  );
}
